import React from 'react'
import FlexView from 'react-flexview/lib'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { ElevatedCircle } from '../ElevatedCircle'
import { ReactComponent as RenewSvg } from '../../../assets/renew.svg'
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { awaitWithLoading } from '../../../services/utils'
import PolicyManagementRenewalApi from '../../../api/policmanagement.renewal.api'
import './AutoRenewTurnOffPopover.scss'

export const AutoRenewTurnOffPopover = ({ insurance, ...props }) => {
  const [open, setOpen] = React.useState(false)
  const [answeredSurvey, setAnsweredSurvey] = React.useState(false)
  const [selectedValue, setSelectedValue] = React.useState(undefined)
  const [input, setInput] = React.useState(undefined)
  const [error, setError] = React.useState(false)
  const [helperText, setHelperText] = React.useState('')

  const handleRadioSelection = (event) => {
    setSelectedValue(event.target.value)
    setHelperText('')
    setError(false)
  }

  const handleInputChange = (event) => {
    setInput(event.target.value)
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleAgree = async () => {
    if (!selectedValue) {
      setHelperText('Please select an option')
      return
    }

    if (selectedValue || input) {
      let res = await awaitWithLoading(
        PolicyManagementRenewalApi.sendAutoRenewCancelReason(
          insurance.insuranceId,
          insurance.policyNumber,
          selectedValue,
          input
        )
      )

      setSelectedValue('')
      setInput('')

      EventEmitterService.dispatch(EventKey.SHOW_PARENT_POPUP_FINISH)
      setAnsweredSurvey(true)
    }
  }

  const handleThankYou = () => {
    setOpen(false)
    setAnsweredSurvey(false)
  }

  React.useEffect(() => {
    setHelperText('')

    let id = EventEmitterService.subscribe(
      EventKey.OPEN_AUTO_RENEW_WINDOW,
      () => {
        handleClickOpen()
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.OPEN_AUTO_RENEW_WINDOW, id)
    }
  }, [])

  return (
    <SkywatchDialog
      open={open}
      excludeCloseIcon={true}
      includeCancelButton={false}
      maxWidth={'md'}
      fullWidth={false}
      narrowContainer={isMobile ? false : true}
      circleHeader={
        <ElevatedCircle>
          <RenewSvg className="medium-icon blue-svg-path" fontSize="large" />
        </ElevatedCircle>
      }
      closeTitle={''}>
      {answeredSurvey ? (
        <FlexView column>
          <div className="text-title blue bold margin-top-basic textcenter margin-bottom">
            Thank You!
          </div>
          <div className=" margin-top-basic textcenter margin-bottom">
            Thank you for taking the time to share your feedback. We appreciate
            it!
          </div>
          <Button
            className="survey-submit-button"
            flat
            onClick={handleThankYou}
            color="primary">
            Close
          </Button>
        </FlexView>
      ) : (
        <FlexView column id={'parent-holder-form'}>
          <div className="text-title blue bold margin-top-basic textcenter margin-bottom">
            Why did you decide to stop your subscription?
          </div>
          <FormControl
            className={`margin-top-basic margin-left-${isMobile ? 'basic' : 'big'}`}
            error={error}
            variant="standard">
            {/* <FormLabel id="demo-radio-buttons-group-label" >Gender</FormLabel> */}
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="novalue"
              name="radio-buttons-group"
              onChange={handleRadioSelection}>
              <FormControlLabel
                value="out_of_use"
                control={<Radio color="primary" />}
                label="I am no longer flying"
              />
              <FormControlLabel
                value="technical_issues"
                control={<Radio color="primary" />}
                label="I'm having technical issues"
              />
              <FormControlLabel
                value="price"
                control={<Radio color="primary" />}
                label="Cost related reasons"
              />
              <FormControlLabel
                value="another_insurance_provider"
                control={<Radio color="primary" />}
                label="I have another insurance provider"
              />
              <FormControlLabel
                value="product"
                control={<Radio color="primary" />}
                label="The product / service does not meet my expectations"
              />
              <FormControlLabel
                value="another_skywatch_product"
                control={<Radio color="primary" />}
                label="Purchase another type of skywatch policy"
              />
              <FormControlLabel
                value="other"
                control={<Radio color="primary" />}
                label="Other reason"
              />
            </RadioGroup>
            <FormHelperText className="text-helper">
              {helperText}
            </FormHelperText>
          </FormControl>
          {selectedValue === 'other' && (
            <textarea
              type="text"
              className="input-box margin-top-small"
              placeholder={'Please Provide More Details'}
              onChange={handleInputChange}></textarea>
          )}
          <Button
            className="survey-submit-button"
            flat
            onClick={handleAgree}
            color="primary">
            Submit
          </Button>
        </FlexView>
      )}
    </SkywatchDialog>
  )
}
